import { useCallback, useEffect } from 'react';

import formulaCockcroftGaultPng from '@assets/formula_cockcroft_gault.png';
import { PageTitle } from '@components/PageTitle';
import { Button } from '@components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@components/ui/command';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@components/ui/form';
import { Input } from '@components/ui/input';
import { Label } from '@components/ui/label';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '@components/ui/popover';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@components/ui/select';
import { Separator } from '@components/ui/separator';
import { useAuth } from '@contexts/auth';
import { EGender } from '@enums/Gender';
import errorsValidation from '@errors/validation';
import formatterDecimal from '@formatters/decimal';
import { zodResolver } from '@hookform/resolvers/zod';
import { cn } from '@lib/ui/cn';
import { Check, ChevronRight, ChevronsUpDown, CircleHelp } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { NumberFormatBase, NumericFormat } from 'react-number-format';
import { Link, Navigate } from 'react-router';
import { z } from 'zod';

import { useCorrecaoDoseFuncaoRenal } from './context';

const drugs = [
  { label: 'Amoxicilina', value: 'Amoxicilina' },
  { label: 'Aciclovir', value: 'Aciclovir' },
  { label: 'Amicacina', value: 'Amicacina' },
  { label: 'Amoxicilina-clavulanato', value: 'Amoxicilina-clavulanato' },
  { label: 'Ampicilina', value: 'Ampicilina' },
  { label: 'Ampicilina-sulbactam', value: 'Ampicilina-sulbactam' },
  {
    label: 'Anfotericina B complexo lipídico',
    value: 'Anfotericina B complexo lipídico',
  },
  {
    label: 'Anfotericina B desoxicolato',
    value: 'Anfotericina B desoxicolato',
  },
  { label: 'Anfotericina B lipossomal', value: 'Anfotericina B lipossomal' },
  { label: 'Anidulafungina ', value: 'Anidulafungina ' },
  { label: 'Apixabana', value: 'Apixabana' },
  { label: 'Azitromicina ', value: 'Azitromicina ' },
  { label: 'Caspofungina', value: 'Caspofungina' },
  { label: 'Cefazolina', value: 'Cefazolina' },
  { label: 'Cefepime', value: 'Cefepime' },
  { label: 'Cefotaxime', value: 'Cefotaxime' },
  { label: 'Ceftazidime', value: 'Ceftazidime' },
  { label: 'Ceftriaxona', value: 'Ceftriaxona' },
  { label: 'Cefuroxima', value: 'Cefuroxima' },
  { label: 'Ciprofloxacino', value: 'Ciprofloxacino' },
  { label: 'Claritromicina ', value: 'Claritromicina ' },
  { label: 'Clindamicina', value: 'Clindamicina' },
  { label: 'Dabigatrana', value: 'Dabigatrana' },
  { label: 'Doxiciclina', value: 'Doxiciclina' },
  { label: 'Edoxabana', value: 'Edoxabana' },
  { label: 'Enoxaparina', value: 'Enoxaparina' },
  { label: 'Eritromicina', value: 'Eritromicina' },
  { label: 'Ertapenem', value: 'Ertapenem' },
  { label: 'Etambutol', value: 'Etambutol' },
  { label: 'Etionamida', value: 'Etionamida' },
  { label: 'Flucitosina', value: 'Flucitosina' },
  { label: 'Fluconazol', value: 'Fluconazol' },
  { label: 'Ganciclovir', value: 'Ganciclovir' },
  { label: 'Gentamicina', value: 'Gentamicina' },
  { label: 'Heparina não-fracionada', value: 'Heparina não-fracionada' },
  { label: 'Imipenem ', value: 'Imipenem ' },
  { label: 'Isoniazida', value: 'Isoniazida' },
  { label: 'Itraconazol', value: 'Itraconazol' },
  { label: 'Levofloxacino', value: 'Levofloxacino' },
  { label: 'Linezolida', value: 'Linezolida' },
  { label: 'Meropenem', value: 'Meropenem' },
  { label: 'Metronidazol', value: 'Metronidazol' },
  { label: 'Micafungina', value: 'Micafungina' },
  { label: 'Nitrofurantoína', value: 'Nitrofurantoína' },
  { label: 'Oseltamivir', value: 'Oseltamivir' },
  { label: 'Penicilina G', value: 'Penicilina G' },
  { label: 'Piperacilina-tazobactam', value: 'Piperacilina-tazobactam' },
  { label: 'Pirazinamida', value: 'Pirazinamida' },
  { label: 'Polimixina B', value: 'Polimixina B' },
  { label: 'Rifampicina', value: 'Rifampicina' },
  { label: 'Rivaroxabana', value: 'Rivaroxabana' },
  {
    label: 'Sulfametoxazol-trimetoprima',
    value: 'Sulfametoxazol-trimetoprima',
  },
  { label: 'Teicoplanina', value: 'Teicoplanina' },
  { label: 'Tetraciclina', value: 'Tetraciclina' },
  { label: 'Tigeciclina', value: 'Tigeciclina' },
  { label: 'Tobramicina', value: 'Tobramicina' },
  { label: 'Valganciclovir', value: 'Valganciclovir' },
  { label: 'Vancomicina', value: 'Vancomicina' },
  { label: 'Varfarina', value: 'Varfarina' },
  { label: 'Voriconazol', value: 'Voriconazol' },
];

const formSchema = z.object({
  weight: z.string().min(1, {
    message: errorsValidation.required,
  }),
  age: z.string().min(1, {
    message: errorsValidation.required,
  }),
  gender: z.enum(EGender, {
    message: errorsValidation.required,
  }),
  creatinine: z.string().min(1, {
    message: errorsValidation.required,
  }),
  drug: z.string().min(1, {
    message: errorsValidation.required,
  }),
});

function RenalFunctionDoseCorrection() {
  const { user } = useAuth();
  const {
    age,
    cockcroft,
    creatinine,
    drug,
    drugId,
    drugInfo,
    gender,
    setAge,
    setCreatinine,
    setDrug,
    setGender,
    setWeight,
    weight,
  } = useCorrecaoDoseFuncaoRenal();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: 'onBlur',
    shouldUnregister: true,
    defaultValues: {
      weight: weight.toFixed(1),
      age: String(age),
      gender,
      creatinine: creatinine.toFixed(1),
      drug,
    },
  });

  const handleChangeDrug = useCallback(
    (value: string): void => {
      setDrug(value);
    },
    [setDrug],
  );

  const handleChangeWeight = useCallback(
    (value: string): void => {
      const valueParsed = Number(value.replace(',', '.'));
      setWeight(valueParsed);
    },
    [setWeight],
  );

  const handleChangeAge = useCallback(
    (value: string): void => {
      const valueParsed = Number(value.replace(',', '.'));
      setAge(valueParsed);
    },
    [setAge],
  );

  const handleChangeGender = useCallback(
    (value: EGender): void => {
      setGender(value);
    },
    [setGender],
  );

  const handleChangeCreatinine = useCallback(
    (value: string): void => {
      const valueParsed = Number(value.replace(',', '.'));
      setCreatinine(valueParsed);
    },
    [setCreatinine],
  );

  function onSubmit(): void {
    //
  }

  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === 'weight' && value.weight) {
        handleChangeWeight(value.weight);
      }
      if (name === 'age' && value.age) {
        handleChangeAge(value.age);
      }
      if (name === 'gender' && value.gender) {
        handleChangeGender(value.gender);
      }
      if (name === 'creatinine' && value.creatinine) {
        handleChangeCreatinine(value.creatinine);
      }
      if (name === 'drug' && value.drug) {
        handleChangeDrug(value.drug);
      }
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  if (!user?.accessGranted) {
    return <Navigate replace to="/pagamento" />;
  }

  return (
    <div>
      <PageTitle hasBackButton title="Ajuste de Dose para Função Renal" />
      <Form {...form}>
        <form
          className="mx-auto max-w-3xl"
          onSubmit={form.handleSubmit(onSubmit)}>
          <div className="mb-4 flex flex-row justify-center gap-6">
            <FormField
              control={form.control}
              name="weight"
              render={({ field: { ref, ...rest } }) => (
                <FormItem>
                  <FormLabel>Peso (Kg)</FormLabel>
                  <FormControl>
                    <NumberFormatBase
                      className="[&_input]:w-26 [&_input]:text-center"
                      customInput={Input}
                      format={(value) => formatterDecimal(value, 1)}
                      getCaretBoundary={(formattedValue) => {
                        const boundaryAry = Array.from({
                          length: formattedValue.length + 1,
                        }).map(() => true);
                        boundaryAry[0] = false;
                        boundaryAry[1] = false;
                        boundaryAry[2] = false;
                        return boundaryAry;
                      }}
                      getInputRef={ref}
                      {...rest}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="age"
              render={({ field: { ref, ...rest } }) => (
                <FormItem>
                  <FormLabel>Idade (anos)</FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="[&_input]:w-26 [&_input]:text-center"
                      customInput={Input}
                      getInputRef={ref}
                      {...rest}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>

          <div className="mb-4 flex flex-row justify-center gap-6">
            <FormField
              control={form.control}
              name="gender"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Sexo</FormLabel>
                  <Select onValueChange={field.onChange} value={field.value}>
                    <FormControl>
                      <SelectTrigger onBlur={field.onBlur}>
                        <SelectValue />
                      </SelectTrigger>
                    </FormControl>

                    <SelectContent>
                      {[
                        {
                          label: 'Feminino',
                          value: EGender.Female,
                        },
                        {
                          label: 'Masculino',
                          value: EGender.Male,
                        },
                      ].map((item) => (
                        <SelectItem
                          className="focus:bg-tertiary"
                          key={item.value}
                          value={item.value}>
                          {item.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="creatinine"
              render={({ field: { ref, ...rest } }) => (
                <FormItem className="flex flex-col items-center">
                  <FormLabel>Creat. (mg/dL)</FormLabel>
                  <FormControl>
                    <NumberFormatBase
                      className="[&_input]:w-26 [&_input]:text-center"
                      customInput={Input}
                      format={(value) => formatterDecimal(value, 1)}
                      getCaretBoundary={(formattedValue) => {
                        const boundaryAry = Array.from({
                          length: formattedValue.length + 1,
                        }).map(() => true);
                        boundaryAry[0] = false;
                        boundaryAry[1] = false;
                        boundaryAry[2] = false;
                        return boundaryAry;
                      }}
                      getInputRef={ref}
                      {...rest}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>

          <div className="flex flex-row items-center justify-center">
            <Label className="text-lg">ClCr (Cockcroft & Gault)</Label>
            <Popover>
              <PopoverTrigger asChild>
                <Button className="cursor-pointer" size="icon" variant="ghost">
                  <CircleHelp className="text-foreground" strokeWidth={2} />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-full max-w-lg space-y-4">
                <h1 className="text-secondary text-center font-medium">
                  Cockcroft & Gault
                </h1>
                <img alt="Cockcroft & Gault" src={formulaCockcroftGaultPng} />
              </PopoverContent>
            </Popover>
          </div>

          <div className="mb-4 flex flex-row items-center justify-center gap-2">
            <p>
              <span className="text-tertiary text-lg font-bold">
                {cockcroft === Infinity ? '0.0' : cockcroft.toFixed(1)}
              </span>{' '}
            </p>
            <Label className="text-foreground text-sm font-light">mL/min</Label>
          </div>

          <Separator className="my-4" />

          <div className="mb-4 flex flex-row items-center justify-center gap-2">
            <FormField
              control={form.control}
              name="drug"
              render={({ field }) => (
                <FormItem className="flex w-full max-w-80 flex-col">
                  <FormLabel>Escolha um medicamento</FormLabel>
                  <Popover>
                    <PopoverTrigger asChild className="w-full">
                      <FormControl>
                        <Button
                          className={cn(
                            'aria-invalid:border-destructive hover:text-foreground text-foreground aria-[expanded=true]:border-secondary aria-invalid:focus-visible:ring-0 w-full justify-between font-normal hover:bg-transparent aria-[expanded=true]:outline-1 aria-[expanded=true]:ring-2',
                            !field.value && 'text-muted-foreground',
                          )}
                          role="combobox"
                          variant="outline">
                          {field.value
                            ? drugs.find(
                                (option) =>
                                  option.value.toString() === field.value,
                              )?.label
                            : ''}
                          <ChevronsUpDown className="ml-auto size-4 shrink-0 opacity-50" />
                        </Button>
                      </FormControl>
                    </PopoverTrigger>
                    <PopoverContent className="max-h-[var(--radix-popover-content-available-height)] w-[var(--radix-popover-trigger-width)] p-0">
                      <Command>
                        <CommandInput
                          className="placeholder:text-foreground/70 h-9"
                          placeholder="Buscar..."
                        />
                        <CommandList>
                          <CommandEmpty>Nenhuma opção encontrada.</CommandEmpty>
                          <CommandGroup>
                            {drugs.map((option) => (
                              <CommandItem
                                className="data-[selected=true]:bg-tertiary"
                                key={option.value}
                                onSelect={() => {
                                  form.setValue(
                                    `drug`,
                                    option.value.toString(),
                                    {
                                      shouldValidate: true,
                                    },
                                  );
                                }}
                                value={option.value}>
                                <PopoverClose className="flex w-full flex-row items-center">
                                  <Check
                                    className={cn(
                                      'mr-2 size-4',
                                      option.value.toString() === field.value
                                        ? 'opacity-100'
                                        : 'opacity-0',
                                    )}
                                  />
                                  {option.label}
                                </PopoverClose>
                              </CommandItem>
                            ))}
                          </CommandGroup>
                        </CommandList>
                      </Command>
                    </PopoverContent>
                  </Popover>
                </FormItem>
              )}
            />
          </div>

          <div className="mb-4 flex flex-col gap-2">
            {drugInfo.map((info) => (
              <div className="mt-4 flex flex-col space-y-4" key={info.id}>
                <div>
                  <Label className="mb-2 text-lg">{info.title}</Label>
                </div>

                {info.items.map((item) => (
                  <Label key={item.id.toString()}>{item.text}</Label>
                ))}
              </div>
            ))}

            {drugId && (
              <Link
                className="gap2 my-4 flex flex-row self-center font-bold"
                to={`/medicamentos/${drugId}`}>
                Mais informações <ChevronRight />
              </Link>
            )}
          </div>

          <p className="text-foreground text-center text-xs font-light">
            *Os ajustes posológicos citados acima são indicados para{' '}
            <span className="font-bold">adultos</span>
          </p>
        </form>
      </Form>
    </div>
  );
}

export default RenalFunctionDoseCorrection;
